import { Building, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SectionShell } from "./SectionShell";

const CONTACT_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfGctjmssSGu73JcGfPeECrLstNGZF5w_36ePFOZLw7s-1HPg/viewform";

const BUSINESS_ITEMS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;

export const CompanyProfileSection = () => {
  const { t } = useTranslation();

  return (
    <SectionShell
      id="company"
      icon={<Building aria-hidden="true" focusable="false" />}
      heading={t("company.heading")}
      photo={{ src: "/images/home/company.jpg" }}
    >
      <dl className="company-list">
        <div data-reveal>
          <dt>{t("company.name_label")}</dt>
          <dd>{t("company.name_value")}</dd>
        </div>
        <div data-reveal>
          <dt>{t("company.representative_label")}</dt>
          <dd>{t("company.representative_value")}</dd>
        </div>
        <div data-reveal>
          <dt>{t("company.address_label")}</dt>
          <dd>
            {t("company.address_zip")}
            <br />
            {t("company.address_line1")}
            <br />
            {t("company.address_line2")}
          </dd>
        </div>
        <div data-reveal>
          <dt>{t("company.contact_label")}</dt>
          <dd>
            TEL/FAX 078-600-0611
            <br />
            <a href={CONTACT_FORM_URL} target="_blank" rel="noopener noreferrer">
              <Mail aria-hidden="true" focusable="false" />
              お問い合わせフォームより承ります
            </a>
          </dd>
        </div>
        <div data-reveal>
          <dt>{t("company.business_label")}</dt>
          <dd>
            <ul>
              {BUSINESS_ITEMS.map((n) => (
                <li key={n}>{t(`company.business_item${n}`)}</li>
              ))}
            </ul>
          </dd>
        </div>
      </dl>
    </SectionShell>
  );
};
